import React, { useState, useEffect, useRef } from "react";
import { incrementContractStatus } from "../../Database/Functions";
import { GetContractsList } from "../../Database/Functions";
import ListContracts from "./ListContracts";

import { PATCH, DELETE } from "../../Database/RealtimeDatabase";
import "../../Contracts/ListContracts.scss";

import Section from "../../UI/Section/Section";
import Header from "../../UI/Header/Header";
import AdminTabs from "../AdminTabs/AdminTabs";

import { Form, Alert} from "react-bootstrap";

function AllContracts() {
  const [isLoadingBets, setIsLoadingBets] = useState(true);
  const [contracts, setContracts] = useState();

  const [hasUpdates, setHasUpdates] = useState(false);
  const [alert,setAlert] = useState(false);

  const [filter, setFilter] = useState("");
  const nameRef = useRef();

  function closeContractHandler(id, p) {
    // очищаем все claims
    DELETE("claims/" + id)
      .then(() => {
        incrementContractStatus(p, id);
        setHasUpdates(true);
        setAlert({ msg: "Контракт " + id + " обновлён." });
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        setAlert({ variant: "danger", msg: error.message });
        window.scrollTo(0, 0);
      });
  }
  function assignContractHandler(id, p) {
    PATCH({ party: p }, "contracts/" + id)
      .then((a) => {
        DELETE("claims/" + id); // очищаем все claims
        incrementContractStatus(p, id);
        setAlert({ msg: "Контракт " + id + " назначен на " + p });
        window.scrollTo(0, 0);
        setHasUpdates(true);
      })
      .catch((error) => {
        setAlert({ variant: "danger", msg: error.message });
        window.scrollTo(0, 0);
      });
  }

  function declineClaimHandler(id, p) {
    // отменяем claim только текущий
    DELETE("claims/" + id + "/" + p)
      .then(() => {
        setAlert({ msg: "Отмена запроса по контракту " + id + "." });
        window.scrollTo(0, 0);
        setHasUpdates(true);
      })
      .catch((error) => {
        setAlert({ variant: "danger", msg: error.message });
        window.scrollTo(0, 0);
      });
  }

  //Load Bets
  useEffect(() => {
    setIsLoadingBets(true);
    GetContractsList()
      .then((items) => {
        setContracts(items.reverse());
        setHasUpdates(false);
        setIsLoadingBets(false);
        setAlert();
      })
      .catch((error) => {
        setAlert({ variant: "danger", msg: error.message });
        window.scrollTo(0, 0);
        setIsLoadingBets(false);
      });
  }, [hasUpdates]);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFilter(nameRef.current.value.toLowerCase());
  };

  if (isLoadingBets) {
    return <p>loading...</p>;
  }
  return (
    <>
      <Section>
        <AdminTabs />
      </Section>
      {alert && (
        <Alert variant={alert.variant ? alert.variant : "success"}>
          {alert.msg}
        </Alert>
      )}
      <Section>
        <Form onSubmit={handleFilterSubmit} className="Form">
          <Form.Group id="terms" className="">
            <Form.Control
              type="text"
              ref={nameRef}
              className={`contracts-list-col`}
              placeholder="Поиск"
              onChange={handleFilterSubmit}
            />
          </Form.Group>
        </Form>
      </Section>
      <Section>
        <Header>Запросы</Header>
        {contracts && (
          <ListContracts
            contracts={contracts.filter(
              (contract) => contract.claims && contract.status < 2 && contract.terms.toLowerCase().includes(filter)
            )}
            onCloseContract={closeContractHandler}
            onAssignContract={assignContractHandler}
            onDeclineContract={declineClaimHandler}
          />
        )}
      </Section>
      <Section>
        <Header>Открыты</Header>
        {contracts && (
          <ListContracts
            contracts={contracts.filter(
              (contract) => !contract.claims && contract.status < 2 && contract.terms.toLowerCase().includes(filter)
            )}
            onCloseContract={closeContractHandler}
            onAssignContract={assignContractHandler}
            onDeclineContract={declineClaimHandler}
          />
        )}
      </Section>
      <Section>
        <Header>Архив</Header>
        {contracts && (
          <ListContracts
            contracts={contracts.filter(
              (contract) => contract.status == 2 && contract.terms.toLowerCase().includes(filter)
            )}
            onCloseContract={closeContractHandler}
            onAssignContract={assignContractHandler}
            onDeclineContract={declineClaimHandler}
          />
        )}
      </Section>
    </>
  );
}
export default AllContracts;
